import React from 'react';

interface CreateProjectModalFooterProps {
  activeStep: number;
  goToNext: () => void;
  goToPrevious: () => void;
  finalStep: number;
  finalStepTitle: string;
  canContinueToNextStep: boolean;
  isFinalStepDisabled: boolean;
  customConfigurationId?: string;
  onFinalStepClicked: () => void;
}

const CreateProjectModalFooter: React.FC<CreateProjectModalFooterProps> = (
  {
    activeStep,
    goToNext,
    goToPrevious,
    finalStep,
    finalStepTitle,
    canContinueToNextStep,
    isFinalStepDisabled,
    customConfigurationId,
    onFinalStepClicked,
  }: CreateProjectModalFooterProps) => {

  const elementsToRender = []

  if (activeStep !== 0) {
    elementsToRender.push(
      <button
        key={'back-button'}
        className={`py-2 px-4 rounded-lg font-semibold bg-brandPurple-500 text-white`}
        onClick={() => goToPrevious()}
      >
        Back
      </button>
    )
  }

  if (activeStep !== finalStep && !customConfigurationId) {
    elementsToRender.push(
      <button
        key={'next-button'}
        className={`py-2 px-4 rounded-lg font-semibold ${
          canContinueToNextStep
            ? "bg-brandPurple-500 text-white"
            : "bg-gray-500 cursor-not-allowed"
        }`}
        disabled={!canContinueToNextStep}
        onClick={() => canContinueToNextStep && goToNext()}
      >
        Next
      </button>
    )
  }

  if (activeStep === finalStep || customConfigurationId) {
    elementsToRender.push(
      <button
        key={'create-button'}
        className={`py-2 px-4 rounded-lg font-semibold ${
          isFinalStepDisabled
            ? "bg-gray-500 cursor-not-allowed"
            : "bg-brandPurple-500 text-white"
        }`}
        disabled={isFinalStepDisabled}
        onClick={onFinalStepClicked}
      >
        {finalStepTitle}
      </button>
    )
  }

  return elementsToRender
}

export default CreateProjectModalFooter;